import client from './api';

const KEY = 'pusubet_ref';
const DEFAULT_DAYS = 30;

/**
 * URL'deki ?ref=XXXXX parametresini yakalar, doğrular ve saklar.
 * Kayıt formu daha sonra getRef() ile bu kodu payload'a ekler.
 */
export const captureRef = async () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const code = (params.get('ref') || params.get('referral') || '').trim().toUpperCase();
    if (!code) return null;

    // Kodun geçerliliğini doğrula ve tıklamayı say
    let days = DEFAULT_DAYS;
    try {
      const { data } = await client.get(`/affiliate/track/${encodeURIComponent(code)}`);
      if (!data.valid) return null;
    } catch {
      // Sunucuya ulaşılamazsa kodu yine sakla; kayıtta tekrar doğrulanır.
    }
    try {
      const { data: terms } = await client.get('/affiliate/terms');
      if (terms?.cookie_days) days = Number(terms.cookie_days);
    } catch { /* varsayılan süre kullanılır */ }

    localStorage.setItem(KEY, JSON.stringify({
      code,
      expires: Date.now() + days * 24 * 60 * 60 * 1000,
    }));
    return code;
  } catch {
    return null;
  }
};

/** Saklanan (ve süresi geçmemiş) referans kodunu döndürür. */
export const getRef = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { code, expires } = JSON.parse(raw);
    if (!code || (expires && Date.now() > expires)) {
      localStorage.removeItem(KEY);
      return null;
    }
    return code;
  } catch {
    return null;
  }
};

/** Kayıt tamamlandıktan sonra kodu temizler. */
export const clearRef = () => {
  try { localStorage.removeItem(KEY); } catch { /* yok sayılır */ }
};

/** Affiliate'in paylaşacağı davet linkini üretir. */
export const buildRefLink = (code) =>
  `${window.location.origin}/?ref=${encodeURIComponent(code || '')}`;
